module.exports = __webpack_public_path__ + "img/sol_internet.ac26c02a.png";